import { render, staticRenderFns } from "./FundInvestment.vue?vue&type=template&id=f3c9af38&scoped=true"
import script from "./FundInvestment.vue?vue&type=script&lang=js"
export * from "./FundInvestment.vue?vue&type=script&lang=js"
import style0 from "./FundInvestment.vue?vue&type=style&index=0&id=f3c9af38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9af38",
  null
  
)

export default component.exports